import { captureEvent } from "@/src/helpers/trackEvent";

// Auth0 silent-token failures only mean the user must re-authenticate when the
// SDK reports a definitive auth-state error. Network blips, transient 5xx from
// /oauth/token, and refresh-token rotation races are recoverable — forcing
// logout on those creates the "logged out upon login" symptom.
const TERMINAL_AUTH_ERRORS = new Set([
  "login_required",
  "consent_required",
  "interaction_required",
  "mfa_required",
  "invalid_grant",
  "missing_refresh_token",
]);

export function shouldLogoutOnAuthError(error) {
  if (!error) return false;
  const code = error.error || error.code || error.error_description;
  if (typeof code === "string" && TERMINAL_AUTH_ERRORS.has(code)) return true;
  if (error.response?.status === 401) return true;
  return false;
}

// Every call site across the app used to repeat `if (shouldLogoutOnAuthError(e))
// logout();` on its own — ~26 places, none of them tracked, so every silent
// forced-logout was invisible. Centralize the check + track + logout here so
// there's exactly one place this ever fires from.
export function logoutOnAuthError(error, logout) {
  if (!shouldLogoutOnAuthError(error)) return false;
  const reason = error?.error || error?.code || error?.error_description || (error?.response?.status === 401 ? "401" : "unknown");
  captureEvent("session_expired", { reason });
  logout();
  return true;
}
